var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_821_614",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_821_614",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAAL2AAAC9gH/U2/cAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAKVQTFRF////AGbMAIC5AHq6AHq4AHu5AHq5AHq5AHq5AHu5AHq5AHq5AHq5AXq5Anu5BXy6B327CH67FYS+Goe/IovBJo3COZbGPZnIRJzJVKTNY6vQZ63Rb7HTc7PUdLTUd7XVfrnXgbrYiL7ZjcDakMLblsXdnsneps3gqM7hrtHistLjvNjlwdrnwtrnxdzn1eTr1uTs2+ft3Ojt4Oru4eru7PDx8fLy9XjvdgAAAAx0Uk5TAAUWMEtqf4Cy0Ob69Vq7RgAAAM9JREFUKJF1UlcWgyAQREUsbBLTe6+aSsre/2ihJC+icX6WNwOzMAshBi5lYRyHjLokDyfg8AFnzo/3Isgh8r68z8EC9z/7C7xU9BlH+cyPQ8tN9Qnkoo14t84weU9lVMteK9vMJdSskkIbSpgqjTRdwzhNe4vTeVI3XqEqTcQLbBBvKDFTTEjivPCc7hAfioltYQRwRWxpwbIaABwQu9qKFYS9EZi5blmg5oElQT5QR5IIkcFSiD7AVoiOjsSEWIAOsTL26kFVj7b6M/z7Pm+BBSK72qbRQgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4fde8d498cfa195e0ac1b0c6f20618fe.svg";
export { ForwardRef as ReactComponent };